import { Link } from "react-router-dom";
import { MessageCircle, FileText } from "lucide-react";
import { FadeUp } from "../Reveal";
import { waLink } from "../../data/site";
import { track } from "../../lib/analytics";

export const FinalCta = () => (
    <section id="orcamento" data-testid="final-cta-section" className="grain relative overflow-hidden bg-ink py-24 sm:py-32 text-white">
        <div className="absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/15 blur-[160px]" />
        <div className="container-x relative text-center">
            <FadeUp>
                <p className="section-tag justify-center flex items-center gap-3">
                    <span className="inline-block h-px w-8 bg-brand" />
                    Último passo
                    <span className="inline-block h-px w-8 bg-brand" />
                </p>
            </FadeUp>
            <FadeUp delay={0.08}>
                <h2 className="mx-auto mt-6 max-w-4xl font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
                    Vamos colocar sua marca para <span className="text-brand">aparecer?</span>
                </h2>
            </FadeUp>
            <FadeUp delay={0.16}>
                <p className="mx-auto mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-mist">
                    Conte o que você precisa. A IMPRIMA AKI encontra a solução mais adequada para o seu projeto.
                </p>
            </FadeUp>
            <FadeUp delay={0.24}>
                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <a
                        href={waLink()}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => track("whatsapp_click", { location: "final_cta" })}
                        data-testid="final-cta-whatsapp"
                        className="group inline-flex items-center gap-3 rounded-full bg-brand px-10 py-5 text-sm font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-brand-dark hover:shadow-[0_14px_50px_rgba(255,85,0,0.45)]"
                    >
                        <MessageCircle size={19} fill="currentColor" />
                        Pedir orçamento no WhatsApp
                    </a>
                    <Link
                        to="/orcamento"
                        data-testid="final-cta-form"
                        className="inline-flex items-center gap-3 rounded-full border border-white/20 px-10 py-5 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:border-brand hover:text-brand"
                    >
                        <FileText size={18} />
                        Preencher formulário
                    </Link>
                </div>
            </FadeUp>
        </div>
    </section>
);
